import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=2b1e6210&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=2b1e6210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e6210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/apps/bowling/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1e6210')) {
      api.createRecord('2b1e6210', component.options)
    } else {
      api.reload('2b1e6210', component.options)
    }
    module.hot.accept("./profile.vue?vue&type=template&id=2b1e6210&scoped=true&", function () {
      api.rerender('2b1e6210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/pages/profile.vue"
export default component.exports